
import { defineComponent } from '@vue/runtime-core'
import ButtonDefault from './ButtonDefault.vue'

export default defineComponent({
    components: {
        ButtonDefault
    },
    emits: ['buttonXModal'],
    setup(props, context){
        const closeModal = () => {
            context.emit('buttonXModal')
        }
        return {
            closeModal
        }
    }
})
